var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMicrophoneMuted = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 25,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 4.083c0-.55.45-1 1-1s1 .45 1 1l-.008 3.259L12.5 8.833V4.167c0-1.384-1.117-2.5-2.5-2.5a2.483 2.483 0 0 0-2.467 2.208L9 5.342V4.083Zm6.833 5.084h-1.416c0 .483-.084.941-.225 1.366l1.058 1.059a5.42 5.42 0 0 0 .583-2.425ZM3.675 2.383 2.5 3.558l5 5v.609c0 1.383 1.117 2.5 2.5 2.5.192 0 .367-.025.542-.067l1.383 1.383a4.582 4.582 0 0 1-1.925.434c-2.3 0-4.417-1.75-4.417-4.25H4.167c0 2.841 2.266 5.191 5 5.6V17.5h1.666v-2.733a5.942 5.942 0 0 0 2.125-.75l3.5 3.5 1.175-1.175L3.675 2.383Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 25
  })))));
};
export { SvgMicrophoneMuted as ReactComponent };